import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/not-found.tsx");
